
import $ from 'jquery';
import Component from './component';
import createComponentFactory from '../createComponent';

class HeaderPanelNavItem extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.$element = $(element);
    this.$control = this.$element.find('.js-headerPanelNavItem__control');
    this.$expandable = this.$element.find('.js-headerPanelNavItem__expandable');

    this._handleControlClick = this._handleControlClick.bind(this);

    this._toggle = this._expand;
  }

  _addEvents() {
    this.$control.on('click', this._handleControlClick);
  }

  _removeEvents() {
    this.$control.off('click', this._handleControlClick);
  }

  _handleControlClick(evt) {

    evt.preventDefault();

    this._toggle();
  }

  _expand() {
    this.$expandable.stop(true, true).slideDown();
    this._toggle = this._collapse;
    this.$element.addClass('c-headerPanelNav__item--expand');
  }

  _collapse() {
    this.$expandable.stop(true, true).slideUp();
    this._toggle = this._expand;
    this.$element.removeClass('c-headerPanelNav__item--expand');
  }

  didRegisterComponent() {
    this._addEvents();
  }

  didUnregisterComponent() {
    this._removeEvents();
  }
}

export default createComponentFactory(HeaderPanelNavItem);



// WEBPACK FOOTER //
// ./src/js/app/component/headerPanelNavItem.js